import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ShoppingBag, User, X } from "lucide-react";
import { LOGO_SRC } from "../../lib/api";
import { useCart } from "../../lib/cart";
import { useAuth } from "../../lib/auth";

export const NAV = [
  ["/shows", "Shows"],
  ["/merch", "Merch"],
  ["/gallery", "Gallery"],
  ["/booking", "Book 00shot"],
  ["/feature", "Feature request"],
  ["/studio", "Studio"],
];

export const Header = () => {
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const [menu, setMenu] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-black/75 backdrop-blur-md border-b border-[#1c2a12]">
      <div className="flex items-center justify-between gap-6 px-5 lg:px-12 h-20">
        <Link to="/home" data-testid="nav-home-logo" className="shrink-0">
          <img src={LOGO_SRC} alt="00shot" className="h-9 lg:h-10 w-auto" />
        </Link>
        <nav className="hidden xl:flex items-center gap-8 font-cond uppercase tracking-[0.14em] text-[15px] font-semibold text-slate-300">
          {NAV.map(([to, label]) => (
            <NavLink key={to} to={to} data-testid={`nav-${to.slice(1)}`} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-5">
          <Link to={user ? (user.role === "admin" ? "/admin" : "/account") : "/login"} data-testid="header-account-link" aria-label="Account"
            className="text-slate-300 hover:text-lime transition-colors">
            <User className="w-5 h-5" />
          </Link>
          <button data-testid="header-cart-button" onClick={() => setOpen(true)} className="relative text-slate-200 hover:text-lime transition-colors" aria-label="Cart">
            <ShoppingBag className="w-5 h-5" />
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -top-2 -right-2.5 bg-lime text-black text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button className="xl:hidden text-slate-200" data-testid="mobile-menu-button" onClick={() => setMenu((m) => !m)} aria-label="Menu">
            {menu ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {menu && (
        <nav className="xl:hidden border-t border-[#1c2a12] px-5 py-4 grid gap-3 font-cond uppercase tracking-widest text-lg" data-testid="mobile-menu">
          {NAV.map(([to, label]) => (
            <NavLink key={to} to={to} onClick={() => setMenu(false)} data-testid={`mobile-nav-${to.slice(1)}`}
              className={({ isActive }) => (isActive ? "text-lime" : "text-slate-300")}>
              {label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
